import React, {useContext, useEffect, useRef, useState} from 'react';
import {ScrollView, TouchableOpacity, View} from 'react-native';
import {theme} from '@common/theme/theme';
import FilledButtonM from '@common/components/button/FilledButtonM';
import {DimensionsContext, IS_WEB} from '@common/utils/mobileUtils';
import {connect} from 'react-redux';
import {apiIdle, apiRequest} from '@data/redux/actions/api';
import {staticDataService} from '@data/services/staticDataService';
import {authService} from '@data/services/authService';
import {useApiStatus} from "@common/hooks/useApiStatus";
import {useNavigation} from "@react-navigation/native";
import {HomeworkAssistance} from "./HomeWorkAssistance";
import {SubjectSupport} from "./SubjectSupport";
import {useController, useForm} from "react-hook-form";
import {ImageViewerModal, pickImage} from "@common/camera/CameraImagesM";
import {useRequestsBatch} from "@common/hooks/useRequestsBatch";
import {formIds} from "@data/constants/formConstants";
import StartingFormHeader from "./StartingFormHeader";
import {MenuM} from "@common/components/menu/MenuM";
import {renderers} from "react-native-popup-menu";
import {IconTextM} from "@common/components/icons/IconTextM";
import {useCamera} from "@common/hooks/useCamera";
import {IconImageM} from "@common/components/icons/IconsM";
import {clearLastPhoto} from "@data/redux/actions/camera";
import {IconButton} from "react-native-paper";
import {congratsTypes} from "@common/screens/CongratsScreen";
import {putCongrats, putNextScreenParams} from "@data/redux/actions/navigation";
import {DialogM} from "@common/components/alert/dialog/Dialog";

const TrialSessionPreparationForm = (props) => {

    const [images, setImages] = useState([]);
    const [openImageViewer, setOpenImageViewer] = useState(false)
    const zoomRef = useRef();
    const dimensions = useContext(DimensionsContext);
    const navigation = useNavigation()
    const desiredSupport = props.user?.profile?.desired_support
    const prioritizedSubjects = props?.user?.prioritized_school_subjects?.map((x) => ({
        label: x?.name,
        value: x?.id,
        icon: x?.icon,
    }))
    const [selectedSchoolSubject, setSelectedSchoolSubject] = useState(prioritizedSubjects?.[0]?.value || null);

    const schoolSubjects = props.schoolSubjects?.map((x) => ({
        label: x?.name,
        value: x?.id,
        icon: x?.icon,
    }))

    const isStep1 = props.user.profile?.desired_support !== "Aide aux devoirs" && props.user.prioritized_school_subjects?.length === 0;
    const isStep2 = !props.user?.profile.parent_evaluation_scores

    const {control, handleSubmit, formState: {errors, dirtyFields}, resetField, getValues, setValue} = useForm({
        defaultValues: {
            chapter: ""
        }
    })
    const {field: chapterField} = useController({
        control,
        name: "chapter"
    })
    const isFormValid = (control?._formValues?.chapter && !!selectedSchoolSubject) || (control?._formValues?.chapter && control?._formValues?.school_subject_id)

    const [launchCamera] = useCamera(formIds.COMPLETE_PROFILE, true, true)

    useEffect(() => {
        if (!props.trialStaticData) {
            props.apiRequest(staticDataService.getStaticDataTrial);
        }
    }, []);

    const handleSelectSubject = (selectedId) => {
        const selectedSubject = schoolSubjects?.find(x => x.value === selectedId);
        setSelectedSchoolSubject(selectedSubject);
    }
    const hideImageViewer = () => {
        return setOpenImageViewer(false)
    }

    const renderSupportComponent = () => {
        switch (desiredSupport) {
            case 'Aide aux devoirs':
                return <HomeworkAssistance
                    questions={[`Sur quel devoir ou quelle tâche spécifique souhaiteriez-vous que l’on aide ${props.user?.firstname} pendant la séance d’essai ?`,
                        "Sélectionner la matière"]}
                    schoolSubjects={schoolSubjects}
                    selectedSubject={selectedSchoolSubject}
                    handleSelectSubject={handleSelectSubject}
                    field={chapterField}
                    control={control}/>;
            case 'Soutien sur une ou plusieurs matières':
                return (
                    <SubjectSupport
                        userName={props.user?.firstname}
                        selectedSubject={selectedSchoolSubject ?? control._formValues?.school_subject_id}
                        handleSelectSubject={handleSelectSubject}
                        prioritizedSubjects={prioritizedSubjects}
                        schoolSubjects={schoolSubjects}
                        field={chapterField}
                        control={control}
                        errors={errors}
                    />
                );
            default:
                return null;
        }
    };

    useEffect(() => {
        if (
            props.lastPhotoFormId === formIds.COMPLETE_PROFILE
            && !!props.lastPhoto
            && !images?.map(x => x?.uri)?.includes(props.lastPhoto?.uri)
        ) {
            const imagesCopy = images?.map(x => x) ?? []
            imagesCopy?.push(props.lastPhoto)
            setImages(imagesCopy);
            props.clearLastPhoto()
        } else if (
            props.lastPhotoFormId === formIds.COMPLETE_PROFILE
            && props.lastPhotos?.length > 0
        ) {
            const imagesCopy = images?.map(x => x) ?? []
            imagesCopy?.push(...props.lastPhotos)
            setImages(imagesCopy);
            props.clearPhotos()
        }
    }, [props.lastPhoto, props.lastPhotos])

    const [globalProgress, submitted, startRequests] = useRequestsBatch(
        [],
        images,
        formIds.COMPLETE_PROFILE,
        {
            service: authService.postPrepareForTrial,
            data: {
                chapter: control?._formValues?.chapter,
                school_subject_id: selectedSchoolSubject?.value ?? selectedSchoolSubject
            },
            tmpFilesKey: "specific_need_attachment",
            tmpFilesFormatter: (attachmentTmp, index) => {
                return attachmentTmp;
            },
            additionalData: [],
            params: {},
            onSuccessBeforeNext: () => {
            }
        },
        []
    );

    const onSubmit = (data) => {
        if (props.postPrepareForTrialRequest) return
        startRequests()
    };

    useApiStatus(
        authService.postPrepareForTrial, // api service
        null, // success message on toast (string or null)
        true, // error message on toast (true) or keep it in redux state (false)
        () => {
                onFinishSteps()
        } // success callback
    )

    const onFinishSteps = () => {
        if (!props.user?.champion_intros_viewed_at?.zoe) {
            props.putNextScreenParams({
                name: "zoe"
            })

            const nextScreen = {
                nextScreen: "intro"
            }

            const congrats = []

            if (IS_WEB) {
                congrats.push({
                    congratsType: congratsTypes.DOWNLOAD_APP,
                    congratsData: {}
                })
            }

            props.putCongrats(congrats)
            navigation.replace("congrats", {
                ...nextScreen
            })
        } else navigation.goBack()
    }

    const onCloseStep = () => {
        // if (!props.user?.champion_intros_viewed_at?.zoe) {
        //     DialogM.show({
        //         text1: 'Quitter ce formulaire ?',
        //         text2: `Ces informations sont importantes pour préparer au mieux l’accompagnement de ${props.user.firstname}`,
        //         buttonText1: 'Oui, quitter',
        //         onPress: () => {
        //             onFinishSteps()
        //         },
        //         buttonText2: 'Annuler',
        //     })
        // } else {
            navigation.goBack()
        // }
    }

    const onIgnoreStep = () => {
        onFinishSteps()
    }

    return (
        <>
            <ScrollView style={{width: dimensions.width, alignSelf: 'center', flex: 1}}>
                <StartingFormHeader step={2}
                                    totalSteps={2}
                                    stepTitle={" Travail à faire pendant la session d'essai"}
                                    // title={"Compléter son profil"}
                                    title={"Préparez votre essai"}
                                    onClose={onCloseStep}/>
                <View
                    style={{
                        marginBottom: 10,
                        // marginTop: 20,
                        width: dimensions?.width - 20,
                        paddingHorizontal: 20,
                        alignSelf: 'center',
                        alignItems: 'center',
                        flex: 1
                    }}
                >
                    {renderSupportComponent()}
                    {images.length > 0 ? <TouchableOpacity
                            style={{marginVertical: 20}}
                            onPress={() => {
                                setOpenImageViewer(true)
                            }}>
                            <IconImageM source={images[0]?.uri}
                                        resizeMode={"contain"}
                                        width={260}
                                        height={260}
                                        style={{
                                            alignSelf: "center",
                                            // tintColor: theme.colors.primary,
                                            marginTop: 15
                                            // height: 160
                                        }}
                            />
                            <IconButton
                                icon={"trash"}
                                style={{
                                    position: "absolute",
                                    top: 20,
                                    right: -10
                                }}
                                iconColor={theme.colors.light}
                                size={24}
                                onPress={() => {
                                    setImages([])
                                }}
                            />
                        </TouchableOpacity>
                        : <MenuM
                            buttonComponent={<View style={{marginTop: 20}}>
                                <IconTextM
                                    text={"Ajouter une photo du cours ou de l’exercice"}
                                    icon={"plus"}
                                    fontSize={18}
                                    iconSize={30}
                                    style={{
                                        width: null,
                                        marginTop: 10,
                                        marginBottom: 10,
                                        flexDirection: "column",
                                        height: null
                                    }}
                                    textStyle={{width: null, textAlign: 'center'}}
                                    color={theme.colors.primary}
                                />
                            </View>}
                            style={{
                                width:
                                    IS_WEB || dimensions?.width > 800
                                        ? (dimensions?.width * 3) / 5
                                        : "100%",
                                alignSelf: "center"

                                // marginBottom: insets.bottom,
                                // marginTop: 20
                            }}
                            items={[
                                {
                                    icon: "camera",
                                    title: "Prendre une photo",
                                    onPress: () => {
                                        launchCamera();
                                    }
                                },
                                {
                                    icon: "file-image",
                                    title: "Choisir un fichier",
                                    onPress: () => {
                                        pickImage(images, setImages)
                                    }
                                }
                            ]}
                            renderer={renderers.SlideInMenu}
                        />}

                </View>
            </ScrollView>
            <View style={{
                marginTop: 10,
                marginBottom: 0,
                alignSelf: "center",
            }}>
                <FilledButtonM
                    style={{}}
                    onPress={onSubmit}
                    loading={submitted}
                    disabled={submitted || !isFormValid}
                    label="Continuer"
                />
                {/*<FilledButtonM*/}
                {/*    onPress={onCloseStep}*/}
                {/*    mode={"text"}*/}
                {/*    label={"Compléter plus tard"}*/}
                {/*/>*/}
            </View>
            <ImageViewerModal visible={openImageViewer}
                              onDismiss={hideImageViewer}
                              imageIndex={0}
                              images={images?.map(i => i?.uri ?? i)}
            />
        </>
    );
};

const mapStateToProps = (state) => ({
    trialStaticData: state.data.staticData?.trial_static_data,
    schoolSubjects: state.data.staticData?.school_subjects,
    postPrepareForTrialRequest: state.api.postPrepareForTrial?.request,
    getStaticDataTrialRequest: state.api.getStaticDataTrial?.request,
    user: state.data.currentUser?.object,
    lastPhoto: state.camera?.lastPhoto,
    lastPhotos: state.camera?.lastPhotos,
    lastPhotoFormId: state.camera?.formId,
});

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    clearLastPhoto,
    putCongrats,
    putNextScreenParams
};

export default connect(mapStateToProps, mapDispatchToProps)(TrialSessionPreparationForm);
